<template>
  <div class="container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <template v-if="load == true">
        <div id="my-table-id">
          <v-data-table :headers="headers" :items="courselist" sort-by="roletype.name" class="elevation-1 mytable"
            :items-per-page="-1" dense :search="search">
            <template v-slot:top>
              <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Subject List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn class="mb-2 button" outlined rounded small color="white" @click="gotoimport()">Import
                  Subjects</v-btn>
              </v-toolbar>

              <span style="width: 20px"> </span>
              <v-row justify="center" dense>
                <v-col sm="3" md="3" cols="12">
                  <!-- <download-excel
                  :data="courselist"
                  :fields="import_table_fields"
                  worksheet="SubjectMaster"
                  name="SubjectMaster.xls"
                >
                  <v-btn outlined rounded class="btn" color="success">
                    <v-icon>mdi-file-excel</v-icon> Export
                  </v-btn>
                </download-excel> -->
                  <v-btn class="ma-2 no-display " rounded color="success" outlined
                    @click="fnExcelReport('my-table-id', 'SubjectMaster')" :loading="loader"><v-icon
                      color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
                <v-col sm="6" md="4" cols="12">
                  <v-text-field v-model="search" append-icon="search" label="Search" single-line
                    hide-details></v-text-field>
                </v-col>
                <span style="width: 20px"> </span>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mb-2 button" v-on="on" small>New Subject</v-btn> </template>x
                  <v-card>
                    <v-form v-model="valid">
                      <v-card-title class="toolbar">
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row dense>
                            <v-col cols="12">
                              <v-text-field dense v-model="editedItem.subjectcode" label="Subject code"
                                :rules="[(v) => !!v || 'required']"></v-text-field>
                              <span v-if="editedIndex == -1"></span>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field dense v-model="editedItem.subjectname" label="Subject name"
                                :rules="[(v) => !!v || 'required']"></v-text-field>
                              <span v-if="editedIndex == -1"></span>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field dense v-model="editedItem.abbr" label="Abbreviation"
                                :rules="[(v) => !!v || 'required']"></v-text-field>
                              <span v-if="editedIndex == -1"></span>
                            </v-col>
                            <v-col cols="1">
                              <v-hidden v-model="editedItem.course_id" label="id"></v-hidden>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-select dense v-model="editedItem.standard" :items="standardlist"
                                :rules="[(v) => !!v || 'required']" item-text="name" item-value="id" label="Standard"
                                persistent-hint :hint="
                                editedIndex == -1
                                  ? 'Select Standard :: Ist, IInd etc'
                                  : 'noneditable'
                              " :filled="editedIndex == -1 ? false : true" return-object single-line rounded
                                outlined></v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete rounded outlined dense v-model="editedItem.subjecthead_id"
                                :items="employee_list" item-text="name" item-value="id" label="Subject Head"
                                persistent-hint single-line></v-autocomplete>
                            </v-col>
                          </v-row>
                          <!-- <v-row>
                          <v-col cols="12"> 
                            <v-autocomplete
                              dense
                              v-model="editedItem.courseplanner_id"
                              :items="employee_list"
                              item-text="name"
                              item-value="id"
                              label="Course Planner"
                              persistent-hint
                              single-line
                            ></v-autocomplete>
                          </v-col>
                        </v-row> -->
                          <v-row>
                            <v-col cols="6" sm="3" md="2">
                              <v-checkbox v-model="editedItem.isactive" color="success" label="isActive?"></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <div>
                <v-avatar size="25" class="edit-avatar">
                  <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                </v-avatar>
              </div>
            </template>
            <template v-slot:[`item.isactive`]="{ item }">
              <span v-if="item.isactive">
                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
              </span>
              <span v-else>
                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
              </span>
            </template>
          </v-data-table>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader:false,
    valid: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style2",
    errorMsg: {},
    search: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    uid_domain: "",
    load: false,
    dialog: false,
    userlist: {},
    usertype: {},
    headers: [
      { text: "Subject Code", value: "subjectcode" },
      { text: "Subject Name", value: "subjectname" },
      { text: "Abbreviation", value: "abbr" },
      { text: "Standard", value: "standard" },
      { text: "Subject Coordinator", value: "subjecthead" },
      // { text: "Course Planner", value: "courseplanner" },
      { text: "Status", value: "isactive" },
      { text: "Actions", value: "action", sortable: false },
    ],
    import_table_fields: {
      "Subject Code": "subjectcode",
      "Subject Name": "subjectname",
      Abbreviation: "abbr",
      Standard: "standard",
      Subjecthead: "subjecthead",
      Courseplanner: "courseplanner",
      Status: "isactive",
      // "Subject Name" : "subjectname",
    },
    standardlist: "",
    editedIndex: -1,
    editedItem: {
      subjectcode: "",
      subjectname: "",
      abbr: "",
      standard: "",
      course_id: "",
      isactive: "",
      subjecthead_id:"",
      courseplanner_id:"",
    },
    defaultItem: {
      subject_code: "",
      subject_name: "",
      abbrivation: "",
      standard: "",
      course_id: "",
      isactive: "",
      subjecthead:"",
      courseplanner:""
    },
    courselist: "",
    employee_list:[],employee:""
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Subject" : "Edit Subject";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.getsubjectmaster();
  },

  methods: {
    
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Subject Code</th>
      <th>Subject Name</th>
      <th>Abbreviation</th>
      <th>Standard</th>
      <th>Status</th>
     <th>Actions</th>
    </tr>`;

  this.courselist.forEach((item, index) => {
    tab_text += `
    <tr>
      <td>${item.subjectcode|| ''}</td>
      <td>${item.subjectname || ''}</td>
      <td>${item.abbr || ''}</td>
      <td>${item.standard || ''}</td>
      <td>${item.isactive ? 'Active' : 'Inactive'}</td>
      <td>Action</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    gotoimport() {
      let routeData = this.$router.resolve({ name: "import-subject" });
      window.open(routeData.href, "_blank");
    },
    initializeErrorMsgFalse() {
      this.errorMsg.username = false;
      this.errorMsg.userType = false;
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
      this.editedIndex = this.courselist.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.userlist.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.userlist.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      //this.initializeErrorMsgFalse();

      if (this.editedIndex > -1) {
        //edit

        axios
          .post("/Examination/editCourse", this.editedItem)
          .then((res) => {
            if (res.data.msg == "200") {
              this.getsubjectmaster();
              // Object.assign(this.courselist[this.editedIndex], this.editedItem);
              this.showSnackbar("#4caf50", "subject Updated Successfully..."); // show snackbar on success
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      } else {
        //new

        axios
          .post("/Examination/saveCourse", this.editedItem)
          .then((res) => {
            if (res.data.msg == "200") {
              console.log("==> " + res.data);
              this.getsubjectmaster();
              //this.courselist.push(this.editedItem);
              this.showSnackbar(
                "#4caf50",
                "New Subject offered  Successfully..."
              ); // show snackbar on success
            } else if (res.data.msg == "300") {
              this.showSnackbar("#4caf50", res.data.description); // show snackbar on success
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
          });

        this.close();
      }
    },
    getsubjectmaster() {
      axios
        .post("/Examination/addsubjectmaster")
        .then((res) => {
          if (res.data.msg == "200") {
            this.standardlist = res.data.standardlist;
            this.courselist = res.data.courselist;
            this.employee_list = res.data.employee_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
  },

  // isValidated(){
  //    //alert('I am in isValidated()'+this.editedItem.usertype.id)
  //   if(this.editedItem.username && this.editedItem.usertype.id )
  //    {

  //       return true;
  //    }
  //   else{
  //         if(!this.editedItem.username)
  //         {
  //           this.errorMsg.username=true
  //         }
  //         if(!this.editedItem.usertype.id)
  //         {
  //           this.errorMsg.userType=true
  //         }

  //     return false;
  //   }
  //  } // .....end of isValidated()
};
//};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>